import { FC } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { AppState } from '../../store/appState';
import { useLocation } from 'react-router';
import { ReserveListOrderResponse } from '../../store/api';
import { Trans, useTranslation } from 'react-i18next';
import { mapLoanFormat } from '../../../models/LoanFormat';

const ParagraphWithMargin = styled.p`
    margin: 50px 0 15px 0 !important;
`;

export const CheckoutThanks = () => {
    const { t } = useTranslation();
    const { state } = useLocation<ReserveListOrderResponse>();
    const user = useSelector((state: AppState) => state.authentication.kc.tokenParsed);
    const linkedReserveListId = state?.notOrderedLinkedReserveListId;
    const linkedReserveListLoanFormat = state?.notOrderedLinkedReserveListLoanFormat;

    return (
        <div>
            <div className="checkout-thanks bw-wrap medium cold-black a-center">
                {/* eslint-disable jsx-a11y/heading-has-content */}
                <Trans
                    i18nKey="components.checkoutThanks.message"
                    components={{
                        h2: <h2 />,
                        p: <p />,
                        strong: <strong />,
                        em: <em />
                    }}
                    values={{
                        userEmail: user?.email
                    }}
                />
                <div className="bt-line">
                    <Link to="/catalogue" className="bt bt-green large">
                        {t('components.checkoutThanks.backToShop')}
                    </Link>
                    <i style={{ display: 'inline-block', width: '10px' }} />
                    <Link to="/orders" className="bt bt-grey large">
                        {t('components.checkoutThanks.viewOrders')}
                    </Link>
                </div>
                {linkedReserveListId ? (
                    <LinkedReport
                        linkedReserveListId={linkedReserveListId}
                        linkedReserveListLoanFormat={linkedReserveListLoanFormat}
                    />
                ) : null}
            </div>
        </div>
    );
};

export const LinkedReport: FC<{ linkedReserveListId: string; linkedReserveListLoanFormat?: string | null }> = ({
    linkedReserveListId,
    linkedReserveListLoanFormat
}) => {
    const { t } = useTranslation();
    // TODO: check if ePress should be filtered out (current implementation is only for eBooks and eAudiobooks
    const linkedLoanFormat = mapLoanFormat(linkedReserveListLoanFormat);
    const linkedLoanFormatLabel = linkedLoanFormat
        ? ' ' + t(`loanFormat.plain.${linkedLoanFormat?.toLowerCase()}_other`)
        : '';
    const reserveLink = `/assistant/reserve/${linkedReserveListId}`;

    return (
        <div data-testid="linked-report">
            <ParagraphWithMargin>
                {t('components.checkoutThanks.infoText', {
                    loanFormat: linkedLoanFormatLabel
                })}
            </ParagraphWithMargin>
            <Link to={reserveLink} className="bt bt-green large">
                {t('components.checkoutThanks.linkedReportText', {
                    loanFormat: linkedLoanFormatLabel
                })}
            </Link>
        </div>
    );
};
